import React from 'react';
import styles from './EmptyRow.module.scss';

interface EmptyRowProps {
  label: string;
  span?: number;
}

export function EmptyRow({ label, span = 6 }: EmptyRowProps) {
  return (
    <tr>
      <td colSpan={span} className={styles.cell}>
        {label}
      </td>
    </tr>
  );
}
